// extracted by mini-css-extract-plugin
export var label = "_cf-1";
export var reminder = "_cf-0";